/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation CBRRouteCreateMutation($customerAccountId: ID!, $type: CUSTOMER_TYPE!, $displayName: String!) {
  CBRRouteCreate(customerAccountId: $customerAccountId, type: $type, displayName: $displayName) {
    message
    status
  }
}
`
